const enum Pages {
  ROOT = '/',
  MY_COMPANY = '/my-company',
  CONTRACTS = '/contracts',
  METERING_POINTS = '/metering-points',
  CONSUMPTION = '/consumption',
  DOCUMENTS_AND_ACTS = '/documents-and-acts',
  FINANCES = '/finances',
  APPEALS = '/appeals',
  COUNTERPARTY_USERS = '/representatives',
  AUDIT = '/audit',
  AUTH_CALLBACK = '/callback',
  NOT_AUTHORIZED = '/not-authorized',
}

export default Pages;
